import React, { Component } from 'react';
import CharacteristicsCategoriesTable from './CharacteristicsCategoriesTable';
import DemographyTable from './DemographyTable';
import PrototypeModelAccuracyTable from './PrototypeModelAccuracyTable';
import NaiveModelAccuracyTable from './NaiveModelAccuracyTable';
import CategorizationBoundariesTable from './CategorizationBoundariesTable';
import ProportionOfCIUsersRankingTable from './ProportionOfCIUsersRankingTable';
import FunctionalOutcomeTable from './FunctionalOutcomeTable';

export const requests = {  
    Table: 0,
    Title: 1,
    Index: 2,
};
export const tables = {  // this is the index of table 
    Demography: 1,
    CharacteristicsCategories: 2,
    PrototypeModelAccuracy: 3,
    NaiveModelAccuracy: 4,
    CategorizationBoundaries: 5,
    ProportionOfCIUsersRanking: 6,
    FunctionalOutcome: 7,
};

export default class MoreInfoTables extends Component {
    constructor(props){
        super(props);
    }
    render () {
        if (this.props.request === requests.Index)
            return this.getIndex(this.props.Table);
        else if (this.props.request === requests.Title)
            return this.getTitle(this.props.table);
        else 
            return this.getTableContent(this.props.table);
    }
    getIndex(table) {
        return (<span>{this.props.table}</span>);
    }
    getTitle(table) {
        let title = "";
        switch (table) {
            case tables.Demography:
                title = DemographyTable.Title;
                break;
            case tables.CharacteristicsCategories:
                title = CharacteristicsCategoriesTable.Title;
                break;
            case tables.PrototypeModelAccuracy:
                title = PrototypeModelAccuracyTable.Title;
                break;
            case tables.NaiveModelAccuracy:
                title = NaiveModelAccuracyTable.Title;
                break;
            case tables.CategorizationBoundaries:
                title = CategorizationBoundariesTable.Title;
                break;
            case tables.ProportionOfCIUsersRanking:
                title = CategorizationBoundariesTable.Title;
                break;
            case tables.FunctionalOutcome:
                title = FunctionalOutcomeTable.Title;
                break;
            default:
            return <p>Not found table title.</p>
        }
        let index = this.getIndex(table)
        return <span className='sub-heading2'>Table {index} {title}</span>
    }
    getTableContent(table){
        switch (table) {
            case tables.Demography:
                return <DemographyTable />        
            case tables.CharacteristicsCategories:
                return <CharacteristicsCategoriesTable />        
            case tables.PrototypeModelAccuracy:
                return <PrototypeModelAccuracyTable />        
            case tables.NaiveModelAccuracy:
                return <NaiveModelAccuracyTable />  
            case tables.CategorizationBoundaries:
                return <CategorizationBoundariesTable />  
            case tables.ProportionOfCIUsersRanking:
                return <ProportionOfCIUsersRankingTable />  
            case tables.FunctionalOutcome:
                return <FunctionalOutcomeTable />  
            default:
                return <p>Not found table.</p>
        }
    }
}
